import React, { useEffect, useState } from 'react';
import { Typography, Fab, Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import useIngredientStore from '../store/ingredientStore';
import IngredientCard from '../components/ingredients/IngredientCard';
import IngredientEditDialog from '../components/ingredients/IngredientEditDialog';

const IngredientPage = () => {
  const { ingredients, loading, error, fetchIngredients, updateIngredient, createIngredient } = useIngredientStore();
  
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedIngredient, setSelectedIngredient] = useState(null);

  const handleIngredientClick = (ingredient) => {
    setSelectedIngredient(ingredient);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedIngredient(null);
  };

  const handleAddNewIngredient = () => {
    setSelectedIngredient(null);
    setDialogOpen(true);
  };

  const handleIngredientSave = async (formData) => {
    try {
      // Structure the payload with required fields
      const ingredientPayload = {
        name: formData.name,
        measure_unit: formData.measurement,
        category: formData.category
      };

      if (selectedIngredient) {
        await updateIngredient(selectedIngredient.id, ingredientPayload);
      } else {
        await createIngredient(ingredientPayload);
      }
      handleDialogClose();
    } catch (error) {
      console.error('Failed to save ingredient:', error);
    }
  };

  useEffect(() => {
    fetchIngredients();
  }, []);

  if (loading) return <div>Loading ingredients...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <Grid container spacing={2}>
        {ingredients.map((ingredient) => (
          <Grid item xs={12} sm={6} md={4} key={ingredient.id}>
            <IngredientCard 
              ingredient={ingredient} 
              onIngredientClick={handleIngredientClick} 
            />
          </Grid>
        ))}
      </Grid>

      <Fab
        color="primary"
        aria-label="add"
        onClick={handleAddNewIngredient}
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
      >
        <AddIcon />
      </Fab>

      <IngredientEditDialog
        open={dialogOpen}
        ingredient={selectedIngredient}
        onClose={handleDialogClose}
        onSave={handleIngredientSave}
      />
    </div>
  );
};

export default IngredientPage;